<template>
  <div>
    <div class="c-banner">
      <div class="img-box">
        <img src="../../assets/image/bg-list.png">
      </div>
      <div class="txt-box">
        <div class="wrap-s">
          <div class="tit">{{ navObj.title }}</div>
        </div>
      </div>
    </div>

    <div class="inner-page bg-2">
      <div class="sticky-nav">
        <div class="sticky">
          <div class="block">
            <div @click="navClick(index)" v-for="(x, index) in list" :key="index" class="box"
              :class="{ 'active': selectIndex == index }">

              <div class="tit">
                {{ x.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <!-- <div class="title">{{ hostTitle }}</div> -->
        <router-view></router-view>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      list: [],
      selectIndex: 0,
      showList: true,
      navObj: {},
      hostStr: "",
      hostTitle: "",
      newList: [],
      newInfo: {},
    }
  },
  created() {
    this.navObj = JSON.parse(sessionStorage.getItem("list"))
    this.list = this.navObj.children
    this.selectIndex = sessionStorage.getItem("index")
    this.hostStr = this.navObj.title + " > " + this.list[this.selectIndex].title
    this.hostTitle = this.list[this.selectIndex].title
    this.$router.push({ path: this.list[this.selectIndex].path });
  },
  methods: {

    navClick(index) {
      this.selectIndex = index

      sessionStorage.setItem("index", this.selectIndex)
      this.showList = true
      this.hostStr = this.navObj.title + " > " + this.list[this.selectIndex].title
      this.hostTitle = this.list[this.selectIndex].title
      let path = this.$route.path;
      if (path === (this.list[this.selectIndex].path).split('?')[0]) {
        let num = Math.floor(Math.random() * 1000 + 1);
        this.$router.push({
          path: this.list[this.selectIndex].path, query: {
            num: num
          }
        });
      } else {
        this.$router.push({ path: this.list[this.selectIndex].path });
      }
    },
    shoDetial() {
      this.showList = false
    },
    getInfoList(column_id) {
      let self = this
      this.$common.noLoginCallUrl("/api/cp-cms/site/info/getInfoPage",
        {
          column_id,
          pageNo: "1",
          pageCount: "5"
        },
        function (res) {
          if (res.code == "000000") {
            self.newList = res.data.data
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    getInfo(id) {
      let self = this
      this.$common.noLoginCallUrl("/api/cp-cms/site/info/getInfo",
        {
          article_id: id,
        },
        function (res) {
          if (res.code == "000000") {
            self.newInfo = res.data
          } else {
            self.$message.warning(res.msg)
          }
        })
    }
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {

      this.navObj = JSON.parse(sessionStorage.getItem("list"))
      this.list = this.navObj.children
      this.selectIndex = sessionStorage.getItem("index")
      this.hostStr = this.navObj.title + " > " + this.list[this.selectIndex].title
      this.hostTitle = this.list[this.selectIndex].title
      this.$router.push({ path: this.list[this.selectIndex].path });

    },
  }
};
</script>

<style lang="less" scoped>
.c-banner {
  position: relative;
  z-index: 1;
  margin-top: -50px;
}

.c-banner:before {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../assets/image/banner-bg.png");
  z-index: 2;
}

.c-banner .img-box {
  position: relative;
  z-index: 1;
}

.c-banner .img-box img {
  display: block;
  width: 100%;
  height: 20vw;
  object-fit: cover;
}

.c-banner .txt-box {
  position: absolute;
  top: 5vw;
  left: 0;
  width: 100%;
  z-index: 3;
}

.c-banner .wrap-s {
  width: 90%;
  max-width: 1680px;
  margin: 0 auto;
  position: relative;
  z-index: 3;
}

.c-banner .tit {
  font-size: 80px;
  color: #fff;
  font-family: 'HarmonyOS_Sans_SC_Bold';
  text-align: right;
}



.inner-page {
  position: relative;
  z-index: 2;
  margin-top: -15vw;
  padding-top: 15vw;
}

.inner-page:before {
  content: '';
  width: 100%;
  height: 35vw;
  background: url("../../assets/image/inner-bg.png") center top no-repeat;
  background-size: 100% auto;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: -1;
}

.inner-page:after {
  content: '';
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -2;
  pointer-events: none;
}

.inner-page.bg-1 {
  min-height: 90vw;
}

.inner-page.bg-1:after {
  height: 55vw;
  // background: url("../2024images/culture/img-5.jpg") center bottom no-repeat;
  background-size: 100% auto;
}

.inner-page.bg-2 {
  min-height: 30vw;
}

.inner-page.bg-2:after {
  height: 37vw;
  // background: url("../2024images/about/img-1.jpg") center bottom no-repeat;
  background-size: 100% auto;
}

.inner-page.bg-3 {
  min-height: 60.5vw;
}

.inner-page.bg-3:after {
  height: 25.5vw;
  // background: url("../2024images/about/img-4.jpg") center bottom no-repeat;
  background-size: 100% auto;
}

.inner-page .sticky-nav {
  position: absolute;
  top: 12vw;
  bottom: 0;
  left: 0;
  z-index: 4;
}

.inner-page .sticky-nav .sticky {
  position: sticky;
  top: 0;
  height: 100vh;
  max-height: 100%;
  // background: url("../2024images/x-3.png") center center no-repeat;
  background-size: 100% 100%;
  padding: 48px;
  display: flex;
  align-items: center;
}

.inner-page .sticky-nav .sticky:before {
  content: '';
  width: 1px;
  position: absolute;
  top: 0;
  left: 48px;
  top: 24px;
  bottom: 24px;
  background-color: #e5e5e5;
  z-index: 1;
  display: none;
}

.inner-page .sticky-nav .block {
  width: 100%;
  border-left: 1px solid #e5e5e5;
}

.inner-page .sticky-nav .box {
  margin-top: 24px;
  position: relative;
  z-index: 2;
}

.inner-page .sticky-nav .box:nth-of-type(1) {
  margin-top: 0;
}

.inner-page .sticky-nav .box .tit {
  position: relative;
  display: inline-block;
  padding: 0 80px 0 40px;
}

.inner-page .sticky-nav .box .tit:before {
  content: '';
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 5px solid rgba(140, 28, 64, 0.2);
  background-color: #8c1c40;
  background-clip: content-box;
  position: absolute;
  top: 50%;
  left: -11px;
  margin-top: -11px;
  opacity: 0;
  transition: opacity .3s ease;
}

.inner-page .sticky-nav .box .tit {
  display: block;
  font-size: 18px;
  color: #333333;
  transition: color .3s ease;
}

@media (any-hover: hover) {
  .inner-page .sticky-nav .box .tit:hover {
    color: #8c1c40;
  }
}

.inner-page .sticky-nav .box .tit i {
  width: 14px;
  height: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  // background-image: url("../2024images/icon-2.svg");
  position: absolute;
  right: 24px;
  top: 50%;
  margin-top: -4px;
  cursor: pointer;
}



.inner-page .sticky-nav .box.active .tit:before {
  opacity: 1;
}

.main {
  padding: 0 120px 50px 350px;

  // .title {
  //   text-align: center;
  //   font-size: 22px;
  //   margin: 10px 0 30px;
  // }
}

@media screen and (max-width: 1025px) {
  
  .c-banner .img-box img {
    height: 30vh;
  }

  .c-banner .txt-box {
    top: 10vh;
  }
  .c-banner .tit{
    font-size: 36px;
  }
  .main{
    padding: 10px 20px;
  }
  .sticky-nav{
    display: none;
  }
}
</style>